export const ENTER = 'enter';
export const LOGIN = 'login';
export const CONFIGURATION = 'configuration';
export const ACCOUNT = 'account';
export const SELECTION = 'selection';

// STYLE CLASSES
export const OPACITY_DEFAULT = '.7';
export const OPACITY_ACTIVE = '1';
export const OPACITY_INACTIVE = '0';
export const TRANSITION_DURATION_DEFAULT = '.4s';
export const HOME = '.home-body';

// BUTTONS
export const SOUND_BUTTON_HOVER = "SOUND_BUTTON_HOVER";
export const SOUND_BUTTON_CLICK = "SOUND_BUTTON_CLICK";